function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/offer-add-button.js";
import "./travel-insurance-package.js";
import { PackageToggleOfferElement } from "../../lib/package-toggle-offer-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { when } from "lit/directives/when.js";
import { FRIENDLY_ERROR_MESSAGE } from "../../lib/utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var TravelInsurance = /*#__PURE__*/function (_PackageToggleOfferEl) {
  _inherits(TravelInsurance, _PackageToggleOfferEl);

  var _super = _createSuper(TravelInsurance);

  function TravelInsurance() {
    var _this;

    _classCallCheck(this, TravelInsurance);

    _this = _super.call(this);
    _this.coverageType = "BASIC";
    _this.product = "travel";
    return _this;
  }
  /**
   * @ignore
   */


  _createClass(TravelInsurance, [{
    key: "policyAttributes",
    get: function get() {
      return {
        trip_start_date: this.tripStartDate,
        trip_end_date: this.tripEndDate,
        origin: {
          state: this.originState,
          country: this.originCountry
        },
        destination_countries: this.destinationCountries,
        coverage_type: this.coverageType,
        trip_cost: this.tripCost
      };
    }
  }, {
    key: "_renderStandardDisplay",
    value: function _renderStandardDisplay() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a;

      return (_a = this.productController) == null ? void 0 : _a.render({
        complete: function complete() {
          return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <div id=\"multi-offer-wrapper\">\n        <div id=\"offers\">\n          ", "\n        </div>\n        <div class=\"decline-action\">\n          <offer-accordion-header .showIcon=", " .showPromotionalHeader=", " @change=", " .checked=", ">\n            <h1>No, do not protect my trip.</h1>\n          </offer-accordion-header>\n        </div>\n        ", "\n        ", "\n        <section id=\"legal-disclaimer\">\n          <legal-disclaimer></legal-disclaimer>\n        </section>\n      </div>\n    "])), ["BASIC", "COMPREHENSIVE", "COMPREHENSIVE_CFAR"].map(function (coverageType, i) {
            return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <travel-insurance-package \n              data-unique-id=", "\n              .clientId=", " \n              .customerFirstName=", " \n              .customerLastName=", "\n              .customerEmailAddress=", "\n              .customerCity=", "\n              .customerStreetAddress=", "\n              .customerPostalCode=", "\n              .customerState=", "\n              .destinationCountries=", "\n              .originCountry=", "\n              .originState=", "\n              .tripCost=", "\n              .tripStartDate=", "\n              .tripEndDate=", "\n              .coverageType=", "\n              .recommended=", "\n              @offer-state-change=", "\n            ></travel-insurance-package>\n          "])), i, _this2.clientId, _this2.customerFirstName, _this2.customerLastName, _this2.customerEmailAddress, _this2.customerCity, _this2.customerStreetAddress, _this2.customerPostalCode, _this2.customerState, _this2.destinationCountries, _this2.originCountry, _this2.originState, _this2.tripCost, _this2.tripStartDate, _this2.tripEndDate, coverageType, coverageType === "COMPREHENSIVE", _this2.offerStateChangeHandler);
          }), false, false, _this2.decline, _this2.selectedState === SelectedState.DECLINED, when(_this2.errors.length > 0, function () {
            return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          <section id=\"errors\">\n            ", "\n          </section>\n        "])), _this2.errors.map(function (e) {
              return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<p>", "</p>"])), FRIENDLY_ERROR_MESSAGE[e]);
            }));
          }), _this2.renderPaymentElement());
        }
      });
    }
  }]);

  return TravelInsurance;
}(PackageToggleOfferElement);

TravelInsurance.styles = [PackageToggleOfferElement.styles, css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      :host {\n        min-width: 780px;\n      }\n\n      offer-header {\n        --default-vi-font-xl: var(--vi-multi-offer-header-font-size); \n      }\n    \n      @media (max-width: 830px) {\n        #multi-offer-wrapper {\n          margin-top: unset;\n        }\n        :host {\n          min-width: unset;\n        }\n      }\n    "])))];

__decorateClass([property({
  attribute: "coverage-type"
})], TravelInsurance.prototype, "coverageType", 2);

__decorateClass([property({
  attribute: "trip-start-date"
})], TravelInsurance.prototype, "tripStartDate", 2);

__decorateClass([property({
  attribute: "trip-end-date"
})], TravelInsurance.prototype, "tripEndDate", 2);

__decorateClass([property({
  type: Array,
  attribute: "destination-countries"
})], TravelInsurance.prototype, "destinationCountries", 2);

__decorateClass([property({
  type: Number,
  attribute: "trip-cost"
})], TravelInsurance.prototype, "tripCost", 2);

__decorateClass([property({
  attribute: "origin-state"
})], TravelInsurance.prototype, "originState", 2);

__decorateClass([property({
  attribute: "origin-country"
})], TravelInsurance.prototype, "originCountry", 2);

TravelInsurance = __decorateClass([customElement("travel-insurance")], TravelInsurance);
export { TravelInsurance };